import { render, staticRenderFns } from "./MarketUpdates.vue?vue&type=template&id=1d0a10da&scoped=true&"
import script from "./MarketUpdates.vue?vue&type=script&lang=ts&"
export * from "./MarketUpdates.vue?vue&type=script&lang=ts&"
import style0 from "./MarketUpdates.vue?vue&type=style&index=0&id=1d0a10da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a10da",
  null
  
)

export default component.exports